import { render, staticRenderFns } from "./ScreensaverStepTab.vue?vue&type=template&id=29faf230"
import script from "./ScreensaverStepTab.vue?vue&type=script&lang=ts"
export * from "./ScreensaverStepTab.vue?vue&type=script&lang=ts"
import style0 from "./ScreensaverStepTab.vue?vue&type=style&index=0&id=29faf230&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports